<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M8 14.792L15.117 9.517C15.3 9.383 15.379 9.142 15.308 8.925L14.533 6.542L12.883 1.367C12.8 1.125 12.45 1.125 12.367 1.367L10.683 6.542H5.317L3.633 1.367C3.55 1.125 3.2 1.125 3.117 1.367L1.467 6.542L0.692 8.925C0.621 9.142 0.7 9.383 0.883 9.517L8 14.792Z"
    fill="currentColor"
  />
</svg>
